import constants from '../constants'

export function getLiveChannelUpdateURL(channelIds: string[]) {
  const url = constants.liveChannelsRefresh.LIVECHANNELS_UPDATE_API_ENDPOINT
  const params = channelIds.reduce((acc, item) => (`channelIds[]=${item}&${acc}`), '')

  return `${url}?${params}${constants.liveChannelsRefresh.additionalParams}`
}

interface channelIdItem {
  imageURL: string
}

function getImageUrlId(imageUrl : string) {
  /*
    e.g. imageUrl: https://images-na.ssl-images-amazon.com/images/I/71UzfVLcd2L._UY200_RI_.jpg
    or
    https://m.media-amazon.com/images/S/sgp-catalog-images/region_US/fox-030897-Full-Image_GalleryCover-en-US-1548260392209._RI_VFUFQXol8nYLFOdzjDjNJZMiew3dRj2n_TTW_UX667_UY375_.jpg
  */
  const linkLocationRegex = /\/([a-zA-Z0-9\-_]*)[.]/g;
  
  /*
    matches with first example link:
      ['/images-na.', '/71UzfVLcd2L.']

    matches with second example link:
      ['/m.', '/fox-030897-Full-Image_GalleryCover-en-US-1548260392209.']
  */
  const matches = imageUrl.match(linkLocationRegex);
  
  if (Array.isArray(matches) && matches.length > 0) {
    return matches.pop(); // '/71UzfVLcd2L.' or '/fox-030897-Full-Image_GalleryCover-en-US-1548260392209.'
  }
}

export function isChannelUpdated(channelIdItem: channelIdItem, imageUrl: string) {
  return channelIdItem && channelIdItem.imageURL &&
    getImageUrlId(imageUrl) !== getImageUrlId(channelIdItem.imageURL);
}
